var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#563D7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H13.22C14.736 5 15.9536 5.28627 16.868 5.86275C17.7824 6.43922 18.242 7.30588 18.242 8.47059C18.242 9.17647 18.0335 9.78039 17.6166 10.2824C17.1997 10.7843 16.6027 11.1765 15.8257 11.451V11.4902C16.868 11.6745 17.6592 12.0824 18.1946 12.7137C18.7299 13.349 19 14.1412 19 15.098C19 15.6471 18.8816 16.1608 18.6447 16.6353C18.4078 17.1137 18.0382 17.5255 17.5313 17.8706C17.0244 18.2157 16.38 18.4902 15.5888 18.6941C14.7976 18.898 13.8596 19 12.7699 19H5V5ZM7.96108 10.8627H12.7936C13.5042 10.8627 14.0964 10.698 14.5702 10.3608C15.044 10.0235 15.2809 9.5451 15.2809 8.91765C15.2809 8.21176 15.0677 7.71373 14.6413 7.42745C14.2149 7.14118 13.599 6.99608 12.7936 6.99608H7.96108V10.8627ZM7.96108 17H13.1963C14.0964 17 14.7976 16.8078 15.2904 16.4196C15.7878 16.0353 16.0389 15.4863 16.0389 14.7804C16.0389 14.0863 15.7926 13.5569 15.2904 13.1804C14.7882 12.8039 14.0964 12.6235 13.1963 12.6235H7.96108V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).2dd5d2ee59a3b355f13cbb74f3c1192f.svg";
export { ForwardRef as ReactComponent };